import React from 'react';
import { TopNavCreateActions } from '@/components/buttons/TopNavCreateActions';
import NotificationsMenu from '../../NotificationsMenu';
import { AddMenuButton } from '../AddMenuButton';
import { RecentClientsButton } from '../RecentClientsButton';

export const CrmTopNavActions = () => {
	return (
		<>
			<TopNavCreateActions />
			<AddMenuButton />
			<RecentClientsButton />
			<NotificationsMenu />
		</>
	);
};
